module.exports = __webpack_public_path__ + "img/big5-1.e33f905f.jpeg";